import { PageSixty } from "monica-alexandria";
import styled from "styled-components";

export const Subscribe = styled(PageSixty)``

export const Checkout = styled(PageSixty)``

export const CheckoutExtraInput = styled.div`
  border-bottom: 1px dashed var(--greyDark);
  margin-bottom: 2rem;

 
 // margin-top: 1.5rem;

  /* input{
    background: var(--light);
    border: 1px solid var(--greyLight);
    color: var(--black) !important;
    border-radius: 16px;
  } */

  .Invoice{
    margin-bottom: .5rem;

    /* input{
      background: var(--light) !important;
      color: var(--black) !important;
    }
     */
  }
`

export const WidgetBox = styled.div`
  background: ${p => p.theme.low};
  border-radius: var(--smallRadius);
  /* margin-bottom: 2rem; */
  padding: var(--normalPads);
  cursor: pointer;
  transition: 0.2s ease;
  overflow-y: auto;
  height: 100%;              
  /* display: flex;
  flex-direction: column;    
  justify-content: space-between; */

   p{
    font-size: 1.3rem;
   }

   &:hover {
    box-shadow: ${(p) => p.theme.outFocus};
    transition: box-shadow 0.5s;
  }

  h4{
    padding-bottom: 2rem;
  }

`;